<template>

<span class="counter">{{ value }}</span>

</template>

<script>
    export default {

        mounted() {
            bus.$on("updc-" + this.name , (c) => {
                this.value += c;
            })
        },

        props : ['name', 'val'],

        created() {
            this.value = parseInt( this.val );
        },

        data() {
            return {
                isReady : false,
                value : 0,
            }
        },

        methods : {

        }

    }
</script>
